import { Effect, createEvent, createStore, Event } from 'effector';
import { PaginationProps } from 'antd/lib/pagination';
import { DEFAULT_PAGE_SIZE } from '@constants/pagination';
import { get } from 'lodash';
import { changeParams } from '@helpers/navigation';

export const initialPaginationParams: PaginationProps = {
  current: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  total: 0,
};
interface IPaginationFabricConfig {
  getList: Effect<any, any, Error>;
  listName: string;
  resetEvent: Event<void>;
  bodyPath?: string[];
  syncWithQuery?: boolean;
}

const createPaginationStore = (config: IPaginationFabricConfig) => {
  const { getList, listName, bodyPath } = config;
  const setPagination: Event<PaginationProps> = createEvent(`Set ${listName} pagination`);
  const pagination = createStore<PaginationProps>(initialPaginationParams)
    .on(getList.done, (state, { result }) => {
      const { pageable, totalElements, number, size, currPage, total, nextPage } = bodyPath
        ? get(result, bodyPath)
        : result.data;
      //  remove this condition after new version pagination will be released
      if (pageable) {
        return {
          current: number + 1,
          pageSize: size,
          total: totalElements,
          showSizeChanger: false,
        };
      } else if (currPage) {
        return {
          current: currPage.page + 1,
          pageSize: currPage.pageSize,
          total: total,
          showSizeChanger: false,
        };
      } else if (nextPage) {
        const { pageSize, page } = nextPage;
        return {
          current: page, // оиждается от бека, сейчас всегда возвращается 1
          pageSize,
          total,
          showSizeChanger: false,
        };
      }
    })
    .on(setPagination, (state, pagination) => {
      return pagination;
    })
    .reset(config.resetEvent);

  if (config.syncWithQuery) {
    getList.watch(({ pagination }) => {
      if (pagination) {
        const size = pagination.pageSize;
        const page = pagination.current ? pagination.current - 1 : 0;
        changeParams({ size, page });
      }
    });
  }

  return { pagination, setPagination };
};

export default createPaginationStore;
